import IconInline from '@/components/IconInline.vue';
import Pic from '@/components/Pic.vue';
import PopupMessage from '@/components/Popup/Message.vue';
import Waiting from '@/components/Waiting.vue';

export default function (app, env) {
    app.component('IconInline', IconInline);
    app.component('Pic', Pic);
    app.component('PopupMessage', PopupMessage);
    app.component('Waiting', Waiting);
}